import { FC } from "react";
import { toDate } from "../../../../lib/date";
import { CellProps, Table } from "rsuite";
import { UserGoodsControl } from "../../../../domain/control/Goods";

export const GoodsControlTableTimestampCell: FC<
  CellProps<UserGoodsControl>
> = ({ rowData, ...props }) => {
  if (!rowData) {
    return null;
  }
  const { timestamp } = rowData;
  return (
    <Table.Cell {...props}>
      <span>{toDate(timestamp)}</span>
    </Table.Cell>
  );
};
